import Creators, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/creators';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default Creators;
